"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataLayer = exports.waitForDataLayer = exports.dataLayerInteractions = exports.sendDataLayerEvent = exports.setDataLayerUser = exports.setDataLayerData = exports.setDataLayerPageData = exports.setupDataLayer = exports.dataLayer = void 0;
const setupDataLayer = () => {
    if (undefined !== window) {
        window.fluidDataLayer = {};
    }
    exports.dataLayer = window.fluidDataLayer.instance;
};
exports.setupDataLayer = setupDataLayer;
const setDataLayerPageData = (pageData) => { var _a; return (_a = (0, exports.getDataLayer)()) === null || _a === void 0 ? void 0 : _a.setPageData(pageData); };
exports.setDataLayerPageData = setDataLayerPageData;
const setDataLayerData = (path, data) => { var _a; return (_a = (0, exports.getDataLayer)()) === null || _a === void 0 ? void 0 : _a.setData(path, data); };
exports.setDataLayerData = setDataLayerData;
const setDataLayerUser = (userData) => { var _a; return (_a = (0, exports.getDataLayer)()) === null || _a === void 0 ? void 0 : _a.setUserData(userData); };
exports.setDataLayerUser = setDataLayerUser;
const sendDataLayerEvent = (eventDetail) => { var _a; return (_a = (0, exports.getDataLayer)()) === null || _a === void 0 ? void 0 : _a.postEvent(eventDetail); };
exports.sendDataLayerEvent = sendDataLayerEvent;
exports.dataLayerInteractions = {
    setPageData: (pageData) => __awaiter(void 0, void 0, void 0, function* () {
        waitForDataLayer().then(dataLayerInstance => dataLayerInstance === null || dataLayerInstance === void 0 ? void 0 : dataLayerInstance.setPageData(pageData)).catch(dataLayerError);
    }),
    setData: (path, data) => __awaiter(void 0, void 0, void 0, function* () {
        waitForDataLayer().then(dataLayerInstance => dataLayerInstance === null || dataLayerInstance === void 0 ? void 0 : dataLayerInstance.setData(path, data)).catch(dataLayerError);
    }),
    setUserData: (userData) => __awaiter(void 0, void 0, void 0, function* () {
        waitForDataLayer().then(dataLayerInstance => dataLayerInstance === null || dataLayerInstance === void 0 ? void 0 : dataLayerInstance.setUserData(userData)).catch(dataLayerError);
    }),
    sendEvent: (eventDetail) => __awaiter(void 0, void 0, void 0, function* () {
        waitForDataLayer().then(dataLayerInstance => dataLayerInstance === null || dataLayerInstance === void 0 ? void 0 : dataLayerInstance.postEvent(eventDetail)).catch(dataLayerError);
    })
};
const dataLayerError = (msg = 'Data Layer instance could not be found. Have you configured it correctly?') => {
    console.error(`%c 🧪 FLUID Data Layer %c  ${msg}`, 'background-color: #9b4dca; color: white; padding: 2px 4px; border-radius: 4px;', 'background-color: #f8d7da; color: #721c24; padding: 2px 4px; border-radius: 4px;');
    return new Error(msg);
};
/**
 * Polls for a data layer instance every <interval> milliseconds for a maximum
 * of <maxRetries> time until it finds the instance, or bombs out.
 * @param interval
 * @param maxRetries
 */
function waitForDataLayer(interval = 200, maxRetries = 15) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            let retries = 0;
            const checkDataLayer = () => {
                const dataLayer = (0, exports.getDataLayer)();
                if (!!dataLayer) {
                    resolve(dataLayer);
                }
                else if (retries < maxRetries) {
                    retries++;
                    setTimeout(checkDataLayer, interval);
                }
                else {
                    reject(new Error('Maximum retries hit when searching for Data Layer instance.'));
                }
            };
            checkDataLayer();
        });
    });
}
exports.waitForDataLayer = waitForDataLayer;
const getDataLayer = () => {
    var _a, _b, _c;
    if (exports.dataLayer) {
        return exports.dataLayer;
    }
    else if (window && window.fluidDataLayer) {
        return window.fluidDataLayer.instance;
    }
    else if (window && ((_c = (_b = (_a = window.parent) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.fluidDataLayer) === null || _c === void 0 ? void 0 : _c.instance)) {
        return window.parent.window.fluidDataLayer.instance;
    }
    else {
        console.warn('No data layer instance available - have you set it up correctly on your page?');
        return undefined;
    }
};
exports.getDataLayer = getDataLayer;
